export enum PartnerInformationFormFields {
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  BIRTH_DATE = "birthDate",
  PHONE_NUMBER = "phoneNumber",
  EMAIL = "email",
  CONSENT = "consent",
}

export type PartnerInformationFormData = {
  firstName: string;
  lastName: string;
  birthDate: Date | undefined;
  consent: boolean;
  phoneNumber?: string;
  email?: string;
};
